import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import ModalFilter from "./filter";
import SearchInput from "../../../../components/inputs/searchInput";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";
import { UseGetMembrosParticipantes } from "../context/getMembros";
import ActionsComponent from "./buttons/actions";


interface HeaderPresencaBatismoProps {

}

const HeaderPresencaBatismo: FunctionComponent<HeaderPresencaBatismoProps> = () => {

  const { getSearchPerMinisterio, getWithParams, reset, listAll } = UseGetMembrosParticipantes();

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>
        <ModalExportar
          callDownloadExcel={() => OpenExcelUniversal(listAll, ["nome", "camisa", "contato", "aula1", "aula2", "reforco", "batismo_8", "batismo_10", "batismo_15", "batismo_17", "batismo_19_30", "descricao"])}
          callDownloadPdf={() => DonwloadPdf(listAll,
            [
              "Nome",
              "Camisa",
              "Contato",
              "Aula 1",
              "Aula 2",
              "Aula Extra",
              "08:00",
              "10:00",
              "15:00",
              "17:00",
              "19:30",
              "Observação"],
            ["nome", "camisa", "contato", "aula1", "aula2", "reforco", "batismo_8", "batismo_10", "batismo_15", "batismo_17", "batismo_19_30", "descricao"], listAll?.length, [], `${listAll?.length}`)
          }
        />
        <ModalFilter
          reset={reset}
          getFilter={getWithParams}
        />

      </section>
      <SearchInput
        placeholder="Procure por nome ou evento"
        onChange={getSearchPerMinisterio} />


      <ActionsComponent />
    </SecaoButao>
  </>);
}

export default HeaderPresencaBatismo;
